import React from 'react';
import { MapPinIcon } from 'lucide-react';
import { Panel } from '../ui/Panel';
import { Badge } from '../ui/Badge';
import { timetable } from '../../data/academics';
import type { ClassSession } from '../../types/academic';
const DAYS: ClassSession['day'][] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
const DAY_NAMES: Record<ClassSession['day'], string> = {
  Mon: 'Monday',
  Tue: 'Tuesday',
  Wed: 'Wednesday',
  Thu: 'Thursday',
  Fri: 'Friday'
};
const TODAY: ClassSession['day'] = 'Thu';
export function TimetableGrid() {
  const contactHours = timetable.reduce((total, session) => {
    const start = Number(session.start.slice(0, 2));
    const end = Number(session.end.slice(0, 2));
    return total + (end - start);
  }, 0);
  return <Panel title="Class timetable" description={`${timetable.length} sessions · ${contactHours} contact hours a week`} bodyClassName="p-0" data-id="element-395" data-mp="lnacq8e4gufq">
      <div className="grid grid-cols-1 divide-y divide-line md:grid-cols-5 md:divide-x md:divide-y-0" data-id="element-396" data-mp="36dj8bysqoykv">
        {DAYS.map(day => {
        const sessions = timetable.filter(session => session.day === day).sort((a, b) => a.start.localeCompare(b.start));
        const isToday = day === TODAY;
        return <div key={day} className={isToday ? 'bg-brand-50/40' : ''} data-id="element-397" data-mp="30b5g6f5un04q">
              <div className="flex items-center justify-between gap-2 border-b border-line px-4 py-2.5" data-id="element-398" data-mp="3596wwtfsynd1">
                <p className="text-[13px] font-semibold text-ink" data-id="element-399" data-mp="2ribmvdtki07v">{DAY_NAMES[day]}</p>
                {isToday && <Badge tone="brand" data-id="element-400" data-mp="2walhh75mnogh">Today</Badge>}
              </div>
              <ul className="space-y-2 px-3 py-3" data-id="element-401" data-mp="2hlfj1lem629n">
                {sessions.length === 0 && <li className="px-1 py-2 text-[12px] text-ink-subtle" data-id="element-402" data-mp="2mjh42bvlobnr">No classes</li>}
                {sessions.map(session => <li key={session.id} className="rounded-lg border border-line bg-surface px-3 py-2.5" data-id="element-403" data-mp="28l0umd6cs71x">
                    <p className="cz-num text-[12px] font-semibold text-brand-800" data-id="element-404" data-mp="j45ceohce3dd">
                      {session.start} — {session.end}
                    </p>
                    <p className="mt-1 text-[13px] font-medium leading-5 text-ink" data-id="element-405" data-mp="9dageseanpeq">
                      {session.title}
                    </p>
                    <p className="cz-num mt-0.5 text-[12px] text-ink-muted" data-id="element-406" data-mp="4fim5rq6fr7d">{session.courseCode}</p>
                    <p className="mt-1 flex items-center gap-1 text-[12px] text-ink-muted" data-id="element-407" data-mp="120n3r4sa4193">
                      <MapPinIcon className="h-3 w-3" data-id="element-408" data-mp="x3wk67h9mnix" />
                      {session.venue}
                    </p>
                  </li>)}
              </ul>
            </div>;
      })}
      </div>
    </Panel>;
}